export default "__VITE_ASSET__BImdh40O__"